module.exports = __webpack_public_path__ + "img/banner03_info_toeic.e3b8963b.svg";